<template>
  <v-checkbox
    v-if="shouldDisplay"
    v-model="isAdditionalConsentChecked"
    :label="$t('subscriptionConfirmation.speedAndAccelerationConfirmation')"
    color="primary"
    data-qa="additional-product-consent-checkbox"
    required
  ></v-checkbox>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AdditionalProductConsent',
  data() {
    return {
      confirmDisabled: true,
      isAdditionalConsentChecked: false,
      shouldDisplay: false,
    };
  },
  mounted() {
    this.onMount();
  },
  computed: {
    ...mapGetters('auth', ['companyCountryCode']),
    ...mapGetters('configuration', [
      'countriesToShowAdditionalConsent',
      'additionalConsentProductSkus',
    ]),
  },
  methods: {
    uncheckBox() {
      this.isAdditionalConsentChecked = false;
    },
    onMount() {
      this.isAdditionalConsentChecked = false;
      if (this.shouldShow()) {
        this.$emit('confirmDisable', {
          confirmDisabled: true,
        });
        this.shouldDisplay = true;
      } else {
        this.shouldDisplay = false;
        this.$emit('confirmDisable', {
          confirmDisabled: false,
        });
      }
    },
    shouldShow() {
      if (
        this.selectedProduct === undefined ||
        this.selectedProduct === null ||
        !this.additionalConsentProductSkus.includes(this.selectedProduct)
      ) {
        return false;
      }
      return this.countriesToShowAdditionalConsent.includes(
        this.companyCountryCode
      );
    },
  },
  props: {
    selectedProduct: String,
  },
  watch: {
    isAdditionalConsentChecked() {
      this.confirmDisabled = !this.isAdditionalConsentChecked;
    },
    confirmDisabled() {
      this.$emit('confirmDisable', {
        confirmDisabled: this.confirmDisabled,
      });
    },
    selectedProduct() {
      this.onMount();
    },
  },
};
</script>
<style scoped>
.v-input--checkbox::v-deep {
  .v-label {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
